// extracted by mini-css-extract-plugin
module.exports = {"AsideContent":"AsideContent_AsideContent__DjSUA","AsideContent__sticky":"AsideContent_AsideContent__sticky__s4C7_"};